var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcons8User(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.002,
    height: 40,
    viewBox: "0 0 32.002 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icons8-user",
    d: "M24,4A10,10,0,1,0,34,14,10.023,10.023,0,0,0,24,4Zm0,3a7,7,0,1,1-7,7A6.977,6.977,0,0,1,24,7ZM11.979,28A4,4,0,0,0,8,31.979V33.5c0,3.6,2.279,6.392,5.307,8.063A22.507,22.507,0,0,0,24,44a22.507,22.507,0,0,0,10.693-2.437A9.666,9.666,0,0,0,39.762,35H40V31.979A4,4,0,0,0,36.021,28Zm0,3H36.021a.958.958,0,0,1,.98.979V32h0v1.5c0,2.4-1.346,4.108-3.756,5.438A19.934,19.934,0,0,1,24,41a19.934,19.934,0,0,1-9.244-2.062C12.346,37.608,11,35.9,11,33.5V31.979A.957.957,0,0,1,11.979,31Z",
    transform: "translate(-8 -4)",
    fill: "#6e6e72"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8User);
export default __webpack_public_path__ + "static/media/icons8-user.1e65a85b.svg";
export { ForwardRef as ReactComponent };